import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material';
import { PulseReport } from '@/types/api';
import { getValueColorIndicator, MaximumvalueIndicators } from '@/utils/charts';
import { dateToMonthDayFormat } from '@/utils/format';
import PulseReportComponent from './PulseReport.component';

interface PulseReportContainerProps {
  pulseReport?: PulseReport;
}

const PulseReportContainer = function ({ pulseReport }: PulseReportContainerProps): JSX.Element {
  const theme = useTheme();

  const [labels, setLabels] = useState<string[]>([]);
  const [averageByWeek, setAverageByWeek] = useState<number[]>([]);
  const [totalAverage, setTotalAverage] = useState<number>(0);
  const [totalAverageColorIndicator, setTotalAverageColorIndicator] = useState<string>('');

  useEffect(() => {
    if (pulseReport) {
      const labelsToSet =
        pulseReport.pulsesWeek?.map(
          (pulseWeek) =>
            `${dateToMonthDayFormat(pulseWeek.startDate)} - ${dateToMonthDayFormat(
              pulseWeek.endDate
            )}`
        ) || [];
      setLabels(labelsToSet);

      const averageByWeekToSet =
        pulseReport.pulsesWeek?.map((pulseWeek) => pulseWeek.avgPulse) || [];
      setAverageByWeek(averageByWeekToSet);

      const totalAverageToSet = pulseReport.avgPulse ?? 0;
      setTotalAverage(totalAverageToSet);
    }
  }, [pulseReport]);

  useEffect(() => {
    const totalAverageColorIndicatorToSet = getValueColorIndicator({
      value: totalAverage,
      maximumIndicator: MaximumvalueIndicators.ONE_TO_FIVE,
      theme,
    });

    setTotalAverageColorIndicator(totalAverageColorIndicatorToSet);
  }, [theme, totalAverage]);

  return (
    <PulseReportComponent
      labels={labels}
      averageByWeek={averageByWeek}
      totalAverage={totalAverage}
      totalAverageColorIndicator={totalAverageColorIndicator}
    />
  );
};

export default PulseReportContainer;
